export default __webpack_public_path__ + "static/media/parole-icon.023f5777.svg";